export const REAL_PRIZES_URL = 'https://docs.skillz.com/docs/unlock-real-prizes/';
